/* eslint-disable @typescript-eslint/camelcase */

import { omitBy } from "lodash";

export function filterEmpty(obj: object) {
  return omitBy(obj, (v) => v == null);
}
